import { combineReducers } from 'redux';

import { authParametersReducer, AuthParametersState, AUTH_PARAMETERS_INITIAL_STATE } from './auth-parameters';
import { changePasswordReducer, ChangePasswordState, CHANGE_PASSWORD_INITIAL_STATE } from './change-password';
import { customerAuthReducer, CustomerAuthState, CUSTOMER_AUTH_INITIAL_STATE } from './customer-auth';
import { loginReducer, LoginState, LOGIN_INITIAL_STATE } from './login';
import { oidcSignupReducer, OidcSignupState, OIDC_SIGNUP_INITIAL_STATE } from './oidc-signup';
import { recoverPassordReducer, RecoverPasswordState, RECOVER_PASSWORD_INITIAL_STATE } from './recover-password';
import { registerReducer, RegisterState, REGISTER_INITIAL_STATE } from './register';

export const AUTH_STATE_KEY = 'auth';

export interface AuthState {
    login: LoginState;
    register: RegisterState;
    oidcSignup: OidcSignupState;
    customer: CustomerAuthState;
    recoverPassword: RecoverPasswordState;
    changePassword: ChangePasswordState;
    authParameters: AuthParametersState;
}

export const AUTH_INITIAL_STATE: AuthState = {
    login: LOGIN_INITIAL_STATE,
    register: REGISTER_INITIAL_STATE,
    oidcSignup: OIDC_SIGNUP_INITIAL_STATE,
    customer: CUSTOMER_AUTH_INITIAL_STATE,
    recoverPassword: RECOVER_PASSWORD_INITIAL_STATE,
    changePassword: CHANGE_PASSWORD_INITIAL_STATE,
    authParameters: AUTH_PARAMETERS_INITIAL_STATE
};

export const AuthReducer = combineReducers<any>({
    login: loginReducer,
    register: registerReducer,
    oidcSignup: oidcSignupReducer,
    customer: customerAuthReducer,
    recoverPassword: recoverPassordReducer,
    changePassword: changePasswordReducer,
    authParameters: authParametersReducer
});

export interface AuthPartialStoreState {
    auth: AuthState;
}
